// UI labels for the blog index and article pages (chrome around the per-post
// content in src/data/blog).

import { type Locale } from "../config";

export const dateLocaleTag: Record<Locale, string> = {
  da: "da-DK",
  en: "en-GB",
  de: "de-DE",
};

type BlogStrings = {
  indexTitle: string;
  /** Full <title> for the article index (indexTitle stays as the visible H1). */
  metaTitle: string;
  indexIntro: string;
  /** Meta description; falls back to indexIntro. */
  metaDescription?: string;
  indexHeroAlt: string;
  backToBlog: string;
  readingTime: (n: number) => string;
  updated: string;
  by: string;
  faqHeading: string;
  relatedHeading: string;
  ctaHeading: string;
  ctaBody: string;
  ctaButton: string;
};

export const blogStrings: Record<Locale, BlogStrings> = {
  da: {
    indexTitle: "Artikler",
    metaTitle: "Artikler om bygge- og projektledelse | MI Support",
    indexIntro:
      "Nyheder, perspektiver og praktisk viden om bygge-, projekt- og sikkerhedsledelse fra MI Support.",
    metaDescription:
      "Nyheder, perspektiver og praktisk viden om bygge-, projekt- og sikkerhedsledelse – skrevet af MI Supports konsulenter fra store byggeprojekter.",
    indexHeroAlt: "MI Support-konsulenter i dialog på kontoret",
    backToBlog: "Tilbage til artikler",
    readingTime: (n) => `${n} min. læsning`,
    updated: "Opdateret",
    by: "Af",
    faqHeading: "Ofte stillede spørgsmål",
    relatedHeading: "Relaterede artikler",
    ctaHeading: "Har I brug for hjælp til jeres projekt?",
    ctaBody:
      "Vores konsulenter står klar til at hjælpe med bygge-, projekt- og sikkerhedsledelse. Tag fat for en uforpligtende snak.",
    ctaButton: "Kontakt os",
  },
  en: {
    indexTitle: "Articles",
    metaTitle: "Articles on construction management | MI Support",
    indexIntro:
      "News, perspectives and practical knowledge about construction, project and safety management from MI Support.",
    indexHeroAlt: "MI Support consultants in dialogue at the office",
    backToBlog: "Back to articles",
    readingTime: (n) => `${n} min read`,
    updated: "Updated",
    by: "By",
    faqHeading: "Frequently asked questions",
    relatedHeading: "Related articles",
    ctaHeading: "Do you need help with your project?",
    ctaBody:
      "Our consultants are ready to help with construction, project and safety management. Get in touch for a no-obligation chat.",
    ctaButton: "Contact us",
  },
  de: {
    indexTitle: "Artikel",
    metaTitle: "Artikel über Bau- und Projektmanagement | MI Support",
    indexIntro:
      "Neuigkeiten, Perspektiven und praktisches Wissen über Bau-, Projekt- und Sicherheitsmanagement von MI Support.",
    indexHeroAlt: "Berater von MI Support im Gespräch im Büro",
    backToBlog: "Zurück zu den Artikeln",
    readingTime: (n) => `${n} Min. Lesezeit`,
    updated: "Aktualisiert",
    by: "Von",
    faqHeading: "Häufig gestellte Fragen",
    relatedHeading: "Verwandte Artikel",
    ctaHeading: "Brauchen Sie Hilfe bei Ihrem Projekt?",
    ctaBody:
      "Unsere Berater helfen Ihnen gern bei Bau-, Projekt- und Sicherheitsmanagement. Nehmen Sie Kontakt auf für ein unverbindliches Gespräch.",
    ctaButton: "Kontaktieren Sie uns",
  },
};
